// THIS FILE IS AUTOMATICALLY GENERATED BY SPACETIMEDB. EDITS TO THIS FILE
// WILL NOT BE SAVED. MODIFY TABLES IN YOUR MODULE SOURCE CODE INSTEAD.

/* eslint-disable */
/* tslint:disable */
import {
  TypeBuilder as __TypeBuilder,
  t as __t,
  type AlgebraicTypeType as __AlgebraicTypeType,
  type Infer as __Infer,
} from "spacetimedb";

export default __t.row({
  memberId: __t.u64().primaryKey().name("member_id"),
  matchId: __t.u64().name("match_id"),
  identity: __t.identity(),
  team: __t.string(),
  ready: __t.bool(),
  alive: __t.bool(),
  eliminatedRound: __t.u8().name("eliminated_round"),
  absent: __t.bool(),
  offlineSince: __t.timestamp().name("offline_since"),
  active: __t.bool(),
  joinedAt: __t.timestamp().name("joined_at"),
  updatedAt: __t.timestamp().name("updated_at"),
});
